export default {
  init() {
    // JavaScript to be fired on all pages

  },
  finalize() {

  },
}